import { BehaviorSubject, Subject } from 'rxjs';
// import { DialogOpenParams } from "./dialog-open-params";
import { CoordinatorService } from './coordinator.service';

export class Gui$ {
    private _isHelpOn = true;

    showMainMenu$ = new BehaviorSubject(true);
    openDialog$ = new Subject();
    // openDialog$ = new Subject<DialogOpenParams>()
    call$ = new Subject();

    constructor(private coords: CoordinatorService) {
        this._isHelpOn = localStorage.getItem('isHelpOn') == 'true';
    }

    get isHelpOn() {
        return this._isHelpOn;
    }

    set isHelpOn(val: boolean) {
        this._isHelpOn = val;
        localStorage.setItem('isHelpOn', val.toString());
    }

    get isMainMenuOn() {
        return this.showMainMenu$.value;
    }
}
